import React from 'react';
import PropTypes from 'prop-types';

import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

import InfoIcon from '@material-ui/icons/InfoOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function ArrangementHelp(props) {
  const { classes, title, content } = props;
  return (
    <Card className={classes.root}>
      <ExpansionPanel
        CollapseProps={{ unmountOnExit: true }}
        onClick={() => {}}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
          IconButtonProps={{ style: { top: '18px' } }}
        >
          <div className={classes.expansionPanelSummaryDiv}>
            <InfoIcon className={classes.avatar} />
            <Typography className={classes.expansionPanelTitle}>
              {title}
            </Typography>
          </div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
          <Typography
            className={classes.expansionPanelContent}
            component="div"
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </Card>
  );
}

ArrangementHelp.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

ArrangementHelp.defaultProps = {};

export default withStyles(styles)(ArrangementHelp);
